import { styled } from 'linaria/react';
import React, { FC } from 'react';
import { Icon } from '@mtsbank/ui-kit';
interface SpinnerProps {
  small?: boolean;
  blackSpinner?: boolean;
}
const OldSpinner: FC<SpinnerProps> = ({
  small,
  blackSpinner
}) => <SpinnerWrapper small={small}>
    <Icon icon={blackSpinner ? 'other/spinner' : 'other/whiteSpinner'} loaderSize={44} />
  </SpinnerWrapper>;
const _exp2 = /*#__PURE__*/() => ({
  small
}) => small ? '24px' : 'auto';
const SpinnerWrapper = /*#__PURE__*/styled('div')({
  name: "SpinnerWrapper",
  class: "s1u4i6d2",
  propsAsIs: false,
  vars: {
    "s1u4i6d2-0": [_exp2()]
  }
});
export default OldSpinner;

require("./OldSpinner.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldSpinner.tsx");